import { SessionStorageKeyType } from 'models';

export function removeFromSessionStorage(key: SessionStorageKeyType) {
	sessionStorage.removeItem(key);
}
